// src/shared/modules/menu/Menu.tsx

import React, { useEffect, useState } from "react";
// import "../../../business-types/laundry/modules/home/App.css";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import { BUSINESS_MENUS } from "./menuConfig";
import { useBusinessSettings } from "./hooks/useBusinessSettings";
import { useActiveMenu } from "./hooks/useActiveMenu";
import MenuItem from "./components/MenuItem";
import MobileMenu from "./components/MobileMenu";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ViewListIcon from "@mui/icons-material/ViewList";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import HomeIcon from "@mui/icons-material/Home";
import CalculateIcon from "@mui/icons-material/Calculate";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import { useUser } from "src/shared/context/UserContext";
import EventNoteIcon from '@mui/icons-material/EventNote';
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import { hasPermission } from "src/shared/components/PermissionRoute";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import FolderIcon from '@mui/icons-material/Folder';

function Menu() {
  const [clickMenu, setClickMenu] = useState(false);
  const [overlayMenu, setOverlayMenu] = useState(true);

  const { businessType, isEmployee, loading } = useBusinessSettings();
  const { user } = useUser();
  const { sidebarThemeClass } = useUserTheme();

  useEffect(() => {
    const menuShow = sessionStorage.getItem("overlayMenu");
    if (menuShow) {
      setClickMenu(menuShow === "true");
    } else {
      setClickMenu(false);
    }
  }, []);

  const menuConfig = BUSINESS_MENUS[businessType] || {};
  const { activeMenu, handleMenuClick } = useActiveMenu(businessType, isEmployee, menuConfig);

  if (!user?.businessType) return null;

  const menuItems = [
    {
      title: "Home",
      path: isEmployee ? menuConfig.employeeHomePath : menuConfig.homePath,
      Icon: HomeIcon,
    },
    {
      title: "Dashboard",
      path: isEmployee ? (menuConfig.employeeDashboardPath ?? menuConfig.dashboardPath) : menuConfig.dashboardPath,
      Icon: DashboardRoundedIcon,
      permission: "dashboard_view",
    },
    {
      title: "Orders",
      path: isEmployee ? (menuConfig.employeeOrderPath ?? menuConfig.orderPath) : menuConfig.orderPath,
      Icon: ViewListIcon,
      permission: "order_view",
    },
    {
      title: "Ledgers",
      path: isEmployee ? menuConfig.employeeLedgerPath : menuConfig.ledgerPath,
      Icon: ImportContactsIcon,
      permission: "customer_view",
    },
    {
      title: "Reports",
      path: menuConfig.DailyReport,
      Icon: EventNoteIcon,
      permission: "report_view",
    },
    {
      title: "Running Order",
      path: menuConfig.runningOrder,
      Icon: DirectionsRunIcon,
      permission: "order_view",
    },
    {
      title: "Catalog",
      path: menuConfig.Catalog,
      Icon: FolderIcon,
      permission: "catalog_view",
    },
    {
      title: "Admin",
      path: menuConfig.settingsPath,
      Icon: SettingsSuggestIcon,
      permission: "management_view",
    },
    {
      title: "Configurations",
      path: menuConfig.Configurations,
      Icon: ManageAccountsIcon,
      permission: "setting_view",
    },
    // {
    //   title: "Tools",
    //   path: menuConfig.toolsPath,
    //   Icon: CalculateIcon,
    //   permission: "tools_view",
    // },
  ];

  const renderMenuItems = (compact: boolean) =>
    menuItems
      .filter(({ permission, path }) => {
        if (!path) return false;

        if (user?.role[0] === "Owner") return true;

        const permissions =
          user?.permissions && !Array.isArray(user.permissions)
            ? user.permissions
            : {};

        return hasPermission(permissions as Record<string, string[]>, permission);
      })
      .map(({ title, path, Icon }) => <MenuItem key={title} title={title} path={path} Icon={Icon} compact={compact} isActive={activeMenu === title} onClick={handleMenuClick} />);

  const dataSet = (value: boolean) => {
    sessionStorage.setItem("overlayMenu", String(value));
    setClickMenu(value);
  };

  return (
    <div className={`pr-2 rounded-r-lg border ${sidebarThemeClass}`} style={{ height: "92vh" , zIndex: 0}}>
      <MobileMenu overlayMenu={overlayMenu} setOverlayMenu={setOverlayMenu} clickmenu={clickMenu} setClickMenu={dataSet}>
        {renderMenuItems(clickMenu)}
      </MobileMenu>

      {loading && <LoadingScreen />}
    </div>
  );
}

export default Menu;
